module.exports = __webpack_public_path__ + "static/media/lp_maurice.a8c9cc0b.jpg";